<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="data"
      :loading="loading"
      loading-text="Завантажую чати"
      sort-by="lastMessageAt"
      class="elevation-1"
      :items-per-page="15"
      :footer-props="{
        'items-per-page-options': [15, 30, 50, -1],
      }"
      height="calc(100vh - 177px)"
    >
      <template v-slot:item.from="{ item }">
        <v-avatar color="teal" size="32" class="mr-3">
          <img v-if="item.avatar" :src="blobContainerUrl + item.avatar" />
          <span v-else class="white--text">{{
            item.from.first_name.charAt(0).toUpperCase()
          }}</span>
        </v-avatar>
        <span>{{ getName(item) }}</span>
      </template>

      <template v-slot:item.lastMessageAt="{ item }">
        <span>{{ formatDate(item.lastMessageAt) }}</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { formatDate, formatTime } from '@/lib/utils';
import { BLOB_CONTAINER_URL } from '@/lib/const';

export default {
  name: 'ChatsTable',

  props: {
    data: Array,
    loading: Boolean,
  },

  data() {
    return {
      blobContainerUrl: BLOB_CONTAINER_URL,

      headers: [
        { text: "Ім'я/Нік", value: 'from' },
        {
          text: 'Останнє повідомлення',
          value: 'lastMessageAt',
        },
      ],
    };
  },

  methods: {
    getName(chat) {
      let name = `${chat.from.first_name || ''} ${chat.from.last_name || ''}`;
      if (name.trim().length === 0) name = chat.from.username;

      return name.trim() || 'No name';
    },

    formatDate(date) {
      return formatDate(date) + ' | ' + formatTime(date);
    },
  },
};
</script>
